import type { Story } from '@/store/story-types'

export const DEV_PORTFOLIO_NEW3_STORY: Story = {
  id: 'dev-portfolio-new3',
  name: 'Alex Chen — Developer Portfolio',
  narrative: 'A developer portfolio with terminal-inspired hero, tech stack showcase, project grid with GitHub links, and contact form. Dark theme with electric-blue accent and monospace typography.',
  goals: ['Showcase developer skills and tech stack', 'Display project portfolio with GitHub links', 'Present professional experience', 'Enable contact via form'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Single-page portfolio with terminal hero, skills, projects, and contact' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'View Tech Stack',
      description: 'Visitor views the developer tech stack',
      steps: [
        { type: 'given', text: 'the visitor opens the portfolio' },
        { type: 'when', text: 'they scroll to the skills section' },
        { type: 'then', text: 'tech stack icons and proficiency levels are displayed', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'Browse Projects',
      description: 'Visitor browses project portfolio',
      steps: [
        { type: 'given', text: 'the visitor is on the portfolio', linkedPageId: 'home' },
        { type: 'when', text: 'they scroll to the projects section' },
        { type: 'then', text: 'project cards with descriptions and GitHub links are visible' },
      ],
    },
    {
      id: 'bdd-3', name: 'Contact Developer',
      description: 'Visitor sends a message',
      steps: [
        { type: 'given', text: 'the visitor scrolls to the contact section' },
        { type: 'when', text: 'they fill out and submit the contact form' },
        { type: 'then', text: 'a success message is shown', linkedFlowId: 'submitContact' },
      ],
    },
  ],
}
